import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import { Race } from "@tvg/ts-types/Race";
import { Track } from "@tvg/ts-types/Track";
import { getWagerProfile } from "@urp/store-selectors";
import useTodaysTracks from "../hooks/useTodaysTracks";
import useTodaysRaces from "../hooks/useTodaysRaces";
import useUserFavoritesWithRedux from "../hooks/useUserFavoritesWithRedux";
import { TRACKS_FETCH_POLICY, TRACKS_POLLER_INTERVAL } from "../constants";

const RaceTracksDataProvider = ({
  children
}: {
  children?: (
    loading: boolean,
    raceDate: string,
    TracksData: Array<Track>,
    RacesData: Array<Race>
  ) => ReactNode;
}) => {
  const wagerProfile = useSelector(getWagerProfile);
  const { loading: loadingTracks, tracks } = useTodaysTracks({
    wagerProfile,
    fetchPolicy: TRACKS_FETCH_POLICY,
    pollInterval: TRACKS_POLLER_INTERVAL
  });
  const {
    loading: loadingRaces,
    raceDate,
    races
  } = useTodaysRaces({ wagerProfile, callSubscribeToMore: true });

  useUserFavoritesWithRedux();

  if (!children) return null;

  return (
    <>{children(loadingTracks || loadingRaces, raceDate, tracks, races)}</>
  );
};

export default RaceTracksDataProvider;
